import React, { useContext, useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Axios from 'axios';
import qs from 'qs';

import Page from '../../Common/Page';

import { AuthContext } from '../../../Data/AuthContext';
import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';
import { isStateValid } from '../../../Utils/AuthenticationHandler';

function LoginPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState('');
    const auth = useContext(AuthContext);
    const location = useLocation();

    useEffect(() => {
        const query = qs.parse(location.search, { ignoreQueryPrefix: true });
        const code = query.code;

        if (code && !auth.isAuthenticated) {
            const state = JSON.parse(atob(query.state));

            if (isStateValid(query.state)) {
                setRedirectUrl(state.redirectUrl);
                setIsLoading(true);
                Axios.get('/auth', { params: { code: code } }).then(res => {
                    setIsLoading(false);
                    auth.login(res.token);
                }, err => {
                    setIsLoading(false);
                    setError(true);
                });
            }
        }
    }, [auth, location.search]);

    if (auth.isAuthenticated) {
        return <Navigate to={redirectUrl} />;
    }

    return (
        <Page centered>
            <h2>Bejelentkezés</h2>
            {isLoading ? <ProgressIndicator /> :
                error ? <ErrorIndicator text="Sikertelen bejelentkezés." /> : null}
        </Page>
    );
}

export default LoginPage;
